import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
declare function CreateQRCode(str: any): any;
@Component({
  selector: 'app-create-qrcode',
  templateUrl: './create-qrcode.component.html',
  styleUrls: ['./create-qrcode.component.scss']
})
export class CreateQrcodeComponent implements OnInit {
  qrcodeObj: any;
  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
    CreateQRCode(this.util.GetUserID());
  }


}



// WEBPACK FOOTER //
// ./src/app/member/create-qrcode/create-qrcode.component.ts